
import React, { Component } from 'react';
import { Box } from 'reactjs-admin-lte'
import { Pagination, Form, FormGroup, Button } from 'react-bootstrap'
// import { momentHelper } from '../helpers'
// import SelectDate from 'component/element/SelectDate'
// import Select from 'react-select'
import PrintButtons from 'component/element/PrintButtons'
import ReportStore from 'stores/ReportStore'
import XLSX from 'xlsx'
import FileSaver from 'file-saver'
import FontAwesome from 'react-fontawesome'
// import DatePicker from 'component/element/DatePicker'
import IframeModal from 'component/element/IframeModal'

import '../report.css'
// import { connect } from 'react-redux';

class ReportOutstandingIncomeSummary extends Component {
  constructor(props) {
    super(props)
    // const WHOLE_YEAR = momentHelper.getMonth() //'00'
    
    this.state = {
      loading:false,
      activePage:1,
      // month: WHOLE_YEAR,
      // year: momentHelper.getYear(),
      data: [],
      // isRange: false,
      // day:momentHelper.getDay(),
      // dayRange:momentHelper.getDay(),
      // monthRange:WHOLE_YEAR,
      // yearRange:momentHelper.getYear()
      type:'',
      insurer_id:'',
      showDetail:false,
      isSubMenu:false,
      subMenu:[]
    }
    this.refTableId = 'ReportOutstandingIncomeSummary-'+Math.ceil(Math.random()*100);
    this.refTableDetailId = 'ReportOutstandingIncomeSummaryDetail-'+Math.ceil(Math.random()*100);
  }

  componentDidMount(){
   
  }

  componentWillReceiveProps(newProps){
    if(newProps.show && newProps.show!==this.props.show){
      this.loadData()
    }
  }

  getNumberFormat(value,decimal=2) {
    let _val = value===''||value===null||value===undefined||isNaN(value) ? 0 : value
    _val = parseFloat(_val)
    return _val.toFixed(decimal).replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
  }

  getSummary(field) {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let val = (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field])
      sum += (val*1)
    })
    return sum
  }

  getDetailSummary(field) {
    let {dataDetail} = this.state
    let total = 0
    dataDetail.forEach((item,index)=> {
        total += (item[field]===''||item[field]===null||item[field]===undefined||isNaN(item[field])?0:item[field]*1)
    }) 
    return total
  }

  getTotalSummary() {
    let {data} = this.state
    let sum = 0
    data.forEach((item,index)=>{
      let wait_qo_amount = (item['wait_qo_amount']===''||item['wait_qo_amount']===null||item['wait_qo_amount']===undefined||isNaN(item['wait_qo_amount'])?0:item['wait_qo_amount'])
      let wait_approve_amount = (item['wait_approve_amount']===''||item['wait_approve_amount']===null||item['wait_approve_amount']===undefined||isNaN(item['wait_approve_amount'])?0:item['wait_approve_amount'])
      let wait_finance_amount = (item['wait_finance_amount']===''||item['wait_finance_amount']===null||item['wait_finance_amount']===undefined||isNaN(item['wait_finance_amount'])?0:item['wait_finance_amount'])
      let finance_amount = (item['finance_amount']===''||item['finance_amount']===null||item['finance_amount']===undefined||isNaN(item['finance_amount'])?0:item['finance_amount'])
      let wait_payment_amount = (item['wait_payment_amount']===''||item['wait_payment_amount']===null||item['wait_payment_amount']===undefined||isNaN(item['wait_payment_amount'])?0:item['wait_payment_amount'])
      sum += (wait_qo_amount*1)+(wait_approve_amount*1)+(wait_finance_amount*1)+(finance_amount*1)+(wait_payment_amount*1)
    })
    return sum
  }

  loadData() {
    this.setState({loading:true})
    ReportStore.loadReportPendingfinanceWork((result)=>{
      this.setState({loading:false,data:result.data})
    })
  }

//   loadDataRange(start='',end='') {
//     ReportStore.loadReportFixingRefixedRange(start,end,(result)=>{
//       this.setState({loading:false,data:result.data})
//     })
//   }

  onTableDetailCloseClick() {
    this.setState({subMenu:[],isSubMenu:false,type:'',insurer_id:'',showDetail:false,dataDetail:[]},()=>{
      if (this.props.onUpdateEventKey!=undefined)
        this.props.onUpdateEventKey(undefined)
    })
  }

  onRowClick(item,type) {
    this.setState({loading:true,insurer_id:item.insurer_id,type:type,subMenu:[{title:(type=='wait_qo'?'รอส่งเรื่อง':type=='wait_approve'?'รออนุมัติราคา':type=='wait_finance'?'รอตั้งเบิก':type=='wait_payment'?'รอรับเงิน':''),key:'s'+0}],isSubMenu:true},()=>{
        if (this.props.onUpdateEventKey!=undefined)
            this.props.onUpdateEventKey('s'+0)
    })
    ReportStore.loadReportPendingfinanceWorkDetail(type,item.insurer_id,(result)=>{
        this.setState({loading:false,dataDetail:result.data,showDetail:true})
    })
  }

  renderBody() {
    let {data} = this.state
    if (data.length==0) {
      return(<tr><td colSpan={12}>ไม่พบข้อมูล</td></tr>)
    } else {
      return(
        data.map((item,index)=>{
            return(
                <tr key={index}>
                    <td className='text-left'>{item.insurer_name}</td>
                    <td className='text-right'>{this.getNumberFormat(item.wait_qo_count,0)}</td>
                    <td className='text-right'><Button onClick={this.onRowClick.bind(this,item,'wait_qo')} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.wait_qo_amount)}</td>
                    <td className='text-right' style={{backgroundColor:'#d5edf8'}}>{this.getNumberFormat(item.wait_approve_count,0)}</td>
                    <td className='text-right' style={{backgroundColor:'#d5edf8'}}><Button onClick={this.onRowClick.bind(this,item,'wait_approve')} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.wait_approve_amount)}</td>
                    <td className='text-right' style={{backgroundColor:'#daf2d7'}}>{this.getNumberFormat(item.wait_finance_count,0)}</td>
                    <td className='text-right' style={{backgroundColor:'#daf2d7'}}><Button onClick={this.onRowClick.bind(this,item,'wait_finance')} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.wait_finance_amount)}</td>
                    <td className='text-right' style={{backgroundColor:'#f5dddd'}}>{this.getNumberFormat(item.finance_count,0)}</td>
                    <td className='text-right' style={{backgroundColor:'#f5dddd'}}>{this.getNumberFormat(item.finance_amount)}</td>
                    <td className='text-right' style={{backgroundColor:'#fcfae1'}}>{this.getNumberFormat(item.wait_payment_count,0)}</td>
                    <td className='text-right' style={{backgroundColor:'#fcfae1'}}><Button onClick={this.onRowClick.bind(this,item,'wait_payment')} bsClass='default' bsSize='xs'><FontAwesome name='search' /></Button> {this.getNumberFormat(item.wait_payment_amount)}</td>
                    <td className='text-right'>{this.getNumberFormat(parseFloat(item.wait_qo_amount)+parseFloat(item.wait_approve_amount)+parseFloat(item.wait_finance_amount)+parseFloat(item.finance_amount)+parseFloat(item.wait_payment_amount))}</td>
                </tr>
            )
        })
      )
    }
  }

  renderBodyDetail() {
    let {dataDetail} = this.state
    if (dataDetail.length==0) {
      return(<tr><td colSpan={8}>ไม่พบข้อมูล</td></tr>)
    } else {
        return(
            dataDetail.map((item,index)=>{
                return(
                    <tr key={index}>
                        <td className='text-center'>{index+1}</td>
                        <td className='text-center'>{item.work_no}</td>
                        <td className='text-center'>{item.work_date}</td>
                        <td className='text-left'>{item.owner_name}</td>
                        <td className='text-center'>{item.car_registration_no}</td>                        
                        <td className='text-center'>{item.brand}</td>
                        <td className='text-center'>{item.model}</td>
                        <td className='text-right'>{this.getNumberFormat(item.amount)}</td>
                    </tr>
                )
            })
        )    
    }
  }

  renderTable() {
    return (
      <div className='display-overflow'>
        <table id={this.refTableId} className='table table-responsive table-hover table-bordered table-report-kkc-income' style={{minWidth:'1200px'}}>
          <thead>
            <tr>
              <th rowSpan={3} className='text-center' style={{width:'110px'}}>สาขา</th>
              <th colSpan={10} className='text-center'>สถานะ</th>
              <th rowSpan={3} className='text-center' style={{width:'100px'}}>รวม</th>
            </tr>
            <tr>
              <th colSpan={2} className='text-center'>รอส่งเรื่อง</th>
              <th colSpan={2} className='text-center'>รออนุมัติราคา</th>
              <th colSpan={2} className='text-center'>รอตั้งเบิก</th>
              <th colSpan={2} className='text-center'>อนุมัติตั้งเบิก/<br/>แจ้งหนี้</th>
              <th colSpan={2} className='text-center'>รอรับเงิน</th>
            </tr> 
            <tr>
              <th className='text-center' style={{width:'60px'}}>เคลม</th>
              <th className='text-center' style={{width:'60px'}}>มูลค่า</th>
              <th className='text-center' style={{width:'60px'}}>เคลม</th>
              <th className='text-center' style={{width:'60px'}}>มูลค่า</th>
              <th className='text-center' style={{width:'60px'}}>เคลม</th>
              <th className='text-center' style={{width:'60px'}}>มูลค่า</th>
              <th className='text-center' style={{width:'60px'}}>เคลม</th>
              <th className='text-center' style={{width:'60px'}}>มูลค่า</th>
              <th className='text-center' style={{width:'60px'}}>เคลม</th>
              <th className='text-center' style={{width:'60px'}}>มูลค่า</th>
            </tr>       
          </thead>
          <tbody>
            {this.renderBody()}
          </tbody>
          <tfoot>
            <tr>
              <th className='text-center'></th>  
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_qo_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_qo_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_approve_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_approve_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_finance_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_finance_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('finance_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('finance_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_payment_count'),0)}</th>
              <th className='text-right'>{this.getNumberFormat(this.getSummary('wait_payment_amount'))}</th>
              <th className='text-right'>{this.getNumberFormat(this.getTotalSummary())}</th>
            </tr>
          </tfoot>
        </table>
      </div>
    )
  }

  renderTableDetail() {
    let {type} = this.state
    return (
        <div className='display-overflow'>
          <table id={this.refTableDetailId} className='table table-responsive table-hover table-bordered-solid table-report-kkc-income'>
            <thead>
              <tr style={{display:'none'}}>
                <th colSpan={8}>{type=='wait_qo'?'รอส่งเรื่อง':type=='wait_approve'?'รออนุมัติราคา':type=='wait_finance'?'รอตั้งเบิก':type=='wait_payment'?'รอรับเงิน':''}</th>
              </tr>  
              <tr>
                <th className='text-center' style={{width:'50px'}}>ลำดับ</th>
                <th className='text-center' style={{width:'100px'}}>หมายเลขใบงาน</th>
                <th className='text-center' style={{width:'120px'}}>วันที่</th>
                <th className='text-center' style={{width:'200px'}}>เจ้าของ</th>
                <th className='text-center' style={{width:'120px'}}>เลขทะเบียน</th>
                <th className='text-center' style={{width:'100px'}}>ยี่ห้อ</th>
                <th className='text-center' style={{width:'100px'}}>รุ่น</th>
                <th className='text-center' style={{width:'100px'}}>มูลค่า</th>
              </tr>
            </thead>
            <tbody>
              {this.renderBodyDetail()}
            </tbody>
            <tfoot>
              <tr>
                <th colSpan={7} className='text-right'>ยอดรวมสุทธิ</th>
                <th className='text-right'>{this.getNumberFormat(this.getDetailSummary('amount'))}</th>
              </tr>
            </tfoot>
          </table>
        </div>
    )
  }

  onPageSelect(eventKey) {
    this.setState({
      activePage: eventKey
    })
    // next... load new page
  }

//   onDayChange(val){
//     this.setState({
//       day: val.value, isRange:false
//     })
//     this.loadData(this.state.year,this.state.month,val.value)
//   }

//   onMonthChange(val) {
//     this.setState({
//       month: val.value, isRange: false
//     })
//     this.loadData(this.state.year,val.value,this.state.day)
//   }

//   onYearChange(val) {
//     this.setState({
//       year: val.value, isRange: false
//     })
//     this.loadData(val.value,this.state.month,this.state.day)
//   }

  onExportExcel(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    const fileName = 'รายงานสรุปยอดรายได้ค้างรับประกัน.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName) 
    this.setState({showExport:false})
  }

  onPrintTable(e) {
    // const {isRange} = this.state
    let url = ''
    let param = 'PrintReportOutstandingIncomeSummary'
    // if (isRange) {
    //     let {day,month,year,dayRange,monthRange,yearRange} = this.state
    //     let start = day+'/'+(month=='00'?'1':month)+'/'+(year-543)
    //     let end = dayRange+'/'+monthRange+'/'+(yearRange-543)
    //     param = 'PrintReportSummaryWork&start_date='+start+'&end_date='+end+'&isRange=true'
    // }    

    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

  onExportExcelDetail(e) {
    const worksheet = XLSX.utils.table_to_book(document.getElementById(this.refTableDetailId));
    let wbout = XLSX.write(worksheet, { bookType: 'xlsx', bookSST: true, type: 'binary' });

    function s2ab(s) {
      var buf = new ArrayBuffer(s.length);
      var view = new Uint8Array(buf);
      for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
      return buf;
    }    
    let {type} = this.state
    let fileName = 'รายงานสรุปยอดรายได้ค้างรับประกัน '+(type=='wait_qo'?'รอส่งเรื่อง':type=='wait_approve'?'รออนุมัติราคา':type=='wait_finance'?'รอตั้งเบิก':type=='wait_payment'?'รอรับเงิน':'')+'.xlsx'
    FileSaver.saveAs(new Blob([s2ab(wbout)], { type: "application/octet-stream" }), fileName)
    this.setState({showExport:false})
  }

  onPrintTableDetail(e) {
    let url = ''
    let param = 'PrintReportOutstandingIncomeSummaryDetail&type='+this.state.type+'&insurerId='+this.state.insurer_id
    if (process.env.NODE_ENV == "development") {
      url  = './?startPage='+param
    } else{
      url = './pdf/v2/?startPage='+param
    }
    this.refs.iframe.loadUrl(url)
  }

//   onStartDateRangeChange(time) {
//     if (time!=''&&time!=undefined&&time!=null) {
//       let _day = time.substr(0,2)
//       let _month = time.substr(3,2)
//       let _year = time.substr(6,10)
//       this.setState({day:_day*1,month:_month,year:_year*1,isRange:false})
//       this.loadData(_year,_month,_day)
//     }
//   }

//   onEndDateRangeChange(time) {
//     if (time!=''&&time!=undefined&&time!=null) {
//       let {day,month,year} = this.state
//       let _day = parseInt(time.substr(0,2))
//       let _month = parseInt(time.substr(3,5))
//       let _year = parseInt(time.substr(6,10))
//       this.setState({isRange:true,dayRange:_day,monthRange:_month,yearRange:_year})
//       year = year - 543
//       _year = _year - 543
//       let start = day+'/'+(month=='00'?'1':month)+'/'+year
//       let end = _day+'/'+_month+'/'+_year
//       this.loadDataRange(start,end)
//     }  
//   }

  renderToolbar() {
    return(
      <Form inline>
        {/* <FormGroup style={{display:'inline-flex',verticalAlign:'top'}}>
          <SelectDate
            wholeYear={true}
            year={this.state.year}
            month={this.state.month}
            day={this.state.day}
            onMonthChange={this.onMonthChange.bind(this)}
            onYearChange={this.onYearChange.bind(this)}
            onDayChange={this.onDayChange.bind(this)}
            dayWCalendar={true}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                // value={this.state.day+'/'+this.state.month+'/'+this.state.year}
                value={(this.state.day=='00'?this.state.dayRange:this.state.day)+'/'+this.state.month+'/'+this.state.year}
                onChange={this.onStartDateRangeChange.bind(this)}
                maxWidth={'100%'}
          />
          <DatePicker 
                style={{display:'inline-block'}}
                height={'36px'}
                none={true}
                showIcon={true}
                showFooter={true}
                popPlacement='bottom'
                buddhistEra
                value={this.state.dayRange+'/'+this.state.monthRange+'/'+this.state.yearRange}
                onChange={this.onEndDateRangeChange.bind(this)}
                maxWidth={'100%'}
          />
        </FormGroup>   */}
        <FormGroup style={{verticalAlign:'top',marginLeft:'0',marginTop:'0',marginBottom:'5px'}}>
          <PrintButtons
            onPrintTable={this.onPrintTable.bind(this)}
            onExportExcel={this.onExportExcel.bind(this)}
            marginLeft='0'
            width='auto'
          />
        </FormGroup>
      </Form>
    )
  }

  renderToolbarDetail() {
    return(
        <Form inline>
            <FormGroup style={{verticalAlign:'top',marginTop:'1.5px',marginBottom:'5px'}}>
                <PrintButtons
                    onPrintTable={this.onPrintTableDetail.bind(this)}
                    onExportExcel={this.onExportExcelDetail.bind(this)}
                    marginLeft='0'
                    width='auto'
                />
            </FormGroup>
        </Form>
    )    
  }

  renderPaging() {
    return (
      <div className="text-center pull-right">
        <Pagination
          prev
          next
          first
          last
          bsSize="medium"
          items={5}
          activePage={this.state.activePage}
          onSelect={this.onPageSelect.bind(this)} />
      </div>
    )
  }

//   getStartDateRangeText() {
//     let {day,month,year} = this.state
//     let txtMonth = momentHelper.getMonthText(month.toString())
//     return day*1+' '+ txtMonth +' '+ year
//   }

//   getEndDateRangeText() {
//     let {dayRange,monthRange,yearRange} = this.state
//     dayRange = dayRange==0?1:dayRange
//     let txtMonth = momentHelper.getMonthText(monthRange.toString())
//     return dayRange +' '+ txtMonth +' '+ yearRange
//   }

//   onRangeClearClick() {
//     this.loadData(this.state.year,this.state.month,this.state.day)
//     this.setState({isRange:false,dayRange:momentHelper.getDay(),monthRange:this.state.month,yearRange:this.state.year})
//   }

//   renderDateRange() {
//     let {isRange} = this.state
//     if (isRange) {
//       return(
//         <div style={{marginBottom:'10px',display:'flex'}}>
//           {this.getStartDateRangeText()} - {this.getEndDateRangeText()}&nbsp;<Button className='btn btn-xs' onClick={this.onRangeClearClick.bind(this)}><FontAwesome name='eraser' />&nbsp;ลบช่วงเวลา</Button>
//         </div>
//       )
//     } else {
//       return('')
//     }  
//   }

  render() {
    const {loading,showDetail} = this.state
    return (
      <Box loading={loading}>
        <Box.Header border={true}>          
          {this.props.renderMenu(this.state.isSubMenu,this.state.subMenu)}
        </Box.Header>
        <Box.Body>
          {showDetail?this.renderToolbarDetail():this.renderToolbar()}
          {showDetail?this.renderTableDetail():this.renderTable()}
          {/* {this.renderPaging()} */}
          <IframeModal ref='iframe' title={'พิมพ์เอกสาร'} />
        </Box.Body>
        {showDetail?
        <Box.Footer>
            <div className=" pull-right">
                <Button bsStyle='default' onClick={this.onTableDetailCloseClick.bind(this)}><FontAwesome name='table' />&nbsp;กลับหน้าตารางหลัก</Button>    
            </div>
        </Box.Footer>
        :''}
      </Box>
    )
  }
}

ReportOutstandingIncomeSummary.defaultProps = {
  show : false
}

export default ReportOutstandingIncomeSummary;





// WEBPACK FOOTER //
// ./src/view/report/analysis/ReportOutstandingIncomeSummary.js